import React from 'react'

function DataReport() {
  return (
    <div>DataReport</div>
  )
}

export default DataReport